import { FeatureFlagDefinitions } from './flags';

export const productionFlags: FeatureFlagDefinitions = {
  channelsApp: { defaultValue: false },
  enableDevPanel: { defaultValue: false },
  resetPasswordPage: { defaultValue: false },
  enableRewards: { defaultValue: true },
  enableMatrix: { defaultValue: true },
  allowEmailRegistration: { defaultValue: true },
  verboseLogging: { defaultValue: false },
  allowEditPrimaryZID: { defaultValue: true },
  enableReadReceiptPreferences: { defaultValue: false },
  enableUserSettings: { defaultValue: true },
  enableTimerLogs: { defaultValue: false },
  enableChannels: { defaultValue: true },
  enableCollapseableMenu: { defaultValue: true },
  enableMeows: { defaultValue: true },
  enableTokenGatedChat: { defaultValue: true },
  enableNotificationsApp: { defaultValue: true },
  enableNotificationsReadStatus: { defaultValue: false },
  enableLoadMore: { defaultValue: true },
  enableComments: { defaultValue: true },
  enableFeedApp: { defaultValue: true },
  enableLinkedAccounts: { defaultValue: true },
  enableZeroWalletSigning: { defaultValue: true },
  enableFeedChat: { defaultValue: true },
  enableAuraZApp: {
    defaultValue: false,
    allowedUserIds: [
      'dca9d449-548b-4fc9-8411-aab7b48bffc0',
      'f977959f-08db-4e09-b730-b5d7a6577481',
      'bcdcdf9b-e278-43c5-ac34-07a21689ab01',
      'a8df265e-5e4c-46e9-a6e5-9da8684f96ac',
    ],
  },
  enableProfile: { defaultValue: true },
  enableUserProfiles: { defaultValue: true },
  enablePostMedia: { defaultValue: true },
};
